/**
 * Miscellaneous Frontend Utilities
 *
 * Applies responsive wrapper styles to iframes in paragraph tags.
 * CSS :has() in _media.scss handles this natively in modern browsers;
 * this provides a vanilla JS fallback for older browsers without :has().
 *
 * @since 1.0.0
 * @since 1.8.0 Converted to vanilla JS — no jQuery dependency.
 */

( function () {
	'use strict';

	/**
	 * Apply responsive wrapper styles to iframes in paragraphs.
	 */
	function applyIframeStyles() {
		const paragraphs = document.querySelectorAll( 'p' );

		paragraphs.forEach( function ( p ) {
			if ( p.querySelector( 'iframe' ) ) {
				p.classList.add( 'devwp-responsive-embed' );
			}
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', applyIframeStyles );
	} else {
		applyIframeStyles();
	}
} )();
